var _g, _path, _path2, _path3, _ellipse, _path4, _ellipse2, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScenarioLimitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_4149_98910)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7802 47.8276C44.8375 46.4934 42.6491 45.5586 40.1001 45.5586C36.6897 45.5586 33.9251 47.2319 33.9251 49.2961C33.9251 49.3602 33.9277 49.424 33.933 49.4873L33.9109 49.502L34.4252 54.9945L50.1862 52.5262L45.7802 47.8276Z",
    fill: "#1A1B1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4888 47.8276C20.4316 46.4935 22.6199 45.5586 25.169 45.5586C28.5793 45.5586 31.344 47.2319 31.344 49.2961C31.344 49.3602 31.3413 49.424 31.336 49.4873L31.3582 49.502L30.8438 54.9945L15.0829 52.5262L19.4888 47.8276Z",
    fill: "#1A1B1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1252 48.625H34.8752L35.6668 54.375H29.3335L30.1252 48.625Z",
    fill: "#1A1B1D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.7917,
    cy: 54.8535,
    rx: 7.125,
    ry: 4.3125,
    fill: "#1A1B1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4168 55.8128C39.6252 54.8545 40.4168 53.8962 41.2085 53.417",
    stroke: "#1A1B1D",
    strokeWidth: 3.67096,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.125,
    cy: 4.3125,
    rx: 7.125,
    ry: 4.3125,
    transform: "matrix(-1 0 0 1 29.6023 50.541)",
    fill: "#1A1B1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8333 55.8128C19.0417 54.8545 19.8333 53.8962 20.625 53.417",
    stroke: "#1A1B1D",
    strokeWidth: 3.67096,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6745 21.7005C49.3854 18.6814 46.3893 16.5654 42.899 16.5654C38.2317 16.5654 34.4481 20.349 34.4481 25.0163C34.4481 25.1617 34.4518 25.3062 34.4591 25.4498L34.4287 25.4831L35.1326 37.9021L56.7024 32.3211L50.6745 21.7005Z",
    fill: "#1A1B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.906 25.4482L30.9377 25.4831L30.2338 37.9021L8.66406 32.3211L14.6859 21.7111C15.9726 18.6863 18.9716 16.5654 22.466 16.5654C27.1333 16.5654 30.9168 20.349 30.9168 25.0163C30.9168 25.1611 30.9132 25.3051 30.906 25.4482Z",
    fill: "#1A1B1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.249 23.501H35.7496L36.8331 36.5023H28.1655L29.249 23.501Z",
    fill: "#1A1B1D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.583,
    cy: 37.585,
    rx: 9.75097,
    ry: 9.75098,
    fill: "#1A1B1D",
    stroke: "white",
    strokeWidth: 4.58869,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3336 39.7522C42.2501 37.5853 43.3336 35.4184 44.417 34.335",
    stroke: "#1A1B1D",
    strokeWidth: 3.67096,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.75098,
    cy: 9.75098,
    rx: 9.75098,
    ry: 9.75098,
    transform: "matrix(-1 0 0 1 28.533 27.834)",
    fill: "#1A1B1D",
    stroke: "white",
    strokeWidth: 4.58869,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1636 39.7522C14.0802 37.5853 15.1636 35.4184 16.2471 34.335",
    stroke: "#1A1B1D",
    strokeWidth: 3.67096,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51 5C51.8324 7.3322 53.6678 9.16756 56 10C53.6678 10.8324 51.8324 12.6678 51 15C50.1676 12.6678 48.3322 10.8324 46 10C48.3322 9.16756 50.1676 7.3322 51 5Z",
    fill: "#1A1B1D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0357 1C57.5411 2.41598 58.6555 3.53031 60.0714 4.03571C58.6555 4.54112 57.5411 5.65545 57.0357 7.07143C56.5303 5.65545 55.416 4.54112 54 4.03571C55.416 3.53031 56.5303 2.41598 57.0357 1Z",
    fill: "#1A1B1D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4654 9.5C59.9708 10.916 61.0851 12.0303 62.5011 12.5357C61.0851 13.0411 59.9708 14.1555 59.4654 15.5714C58.96 14.1555 57.8457 13.0411 56.4297 12.5357C57.8457 12.0303 58.96 10.916 59.4654 9.5Z",
    fill: "#1A1B1D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4149_98910",
    x: 9.5,
    y: 36,
    width: 46,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4149_98910"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenarioLimitation);
export default __webpack_public_path__ + "static/media/scenario-limitation.da92ebef039e37c4f4b0c02a9b07a995.svg";
export { ForwardRef as ReactComponent };